module.exports = __webpack_public_path__ + "img/vote.42710949.gif";